import useConfiguration from 'app/hooks/useConfiguration';

export default function useAttractionOffline({ attractionKey }: { attractionKey: string }) {
  const { data: offline } = useConfiguration({ select: (res) => res.offline.configuration });
  if (!attractionKey) return false;
  return offline?.some((attraction) => attraction.attractionCode === attractionKey);
}
